import { render, staticRenderFns } from "./CenterViewDraft_Ap.vue?vue&type=template&id=2892551b&scoped=true"
import script from "./CenterViewDraft_Ap.vue?vue&type=script&lang=js"
export * from "./CenterViewDraft_Ap.vue?vue&type=script&lang=js"
import style0 from "./CenterViewDraft_Ap.vue?vue&type=style&index=0&id=2892551b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2892551b",
  null
  
)

export default component.exports